<template>
    <div class="content">
        <slot/>
    </div>
</template>
<style scoped>
.content {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: var(--container-max-width);
    width: 100%;
}
</style>
